export const TOGGLE_COMPACT = 'toggle_compact';
export const SET_SETTINGS = 'set_settings';
